import React from 'react';
import {DOTS, usePagination} from "./usePagination";
import {BiChevronLeft, BiChevronRight } from "react-icons/bi";

const Pagination = props => {
    const {
        onPageChange,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize,
    } = props;

    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    // If there are less than 2 times in pagination range we shall not render the component
    if (currentPage === 0 || paginationRange.length < 2) {
        return null;
    }

    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    let lastPage = paginationRange[paginationRange.length - 1];
    return (
        <ul className="pagination_container">
            {/* Left navigation arrow */}
            <button
                onClick={onPrevious}
                className={`pagination_container__item ${currentPage === 1 ? 'pagination_container__item--disabled' : 'pagination_container__item--enabled'}`}
                disabled={currentPage === 1}
            >
                <BiChevronLeft size={24}/>
            </button>
            {paginationRange.map(pageNumber => {
                // If the pageItem is a DOT, render the DOTS unicode character
                if (pageNumber === DOTS) {
                    return <li className="pagination_container__item dots">&#8230;</li>;
                }
                return (
                    <li
                        onClick={() => onPageChange(pageNumber)}
                        className={`pagination_container__item ${currentPage === pageNumber ? 'pagination_container__item--active' : 'pagination_container__item--inactive'}`}
                    >
                        {pageNumber}
                    </li>
                );
            })}
            {/*  Right Navigation arrow */}
            <button
                onClick={onNext}
                disabled={currentPage === lastPage}
                className={`pagination_container__item ${currentPage === lastPage ? 'pagination_container__item--disabled' : 'pagination_container__item--enabled'}`}
            >
                <BiChevronRight size={24}/>
            </button>
        </ul>
    );
};

export default Pagination;